module.exports = __webpack_public_path__ + "static/media/cup_top_3.7c843eb0.webp";